// extracted by mini-css-extract-plugin
export var fcIsTabActive = "fc-is-tab-active__Xjja";
export var fcIsWithBorderRadius = "fc-is-with-border-radius__qYp0";
export var fcTab = "fc-tab__W5L4";